// Section 2 — Third-Party Partner Company onboarding
// Outside corporate partner (may have multiple locations). Distinct from
// stores, brands, and affiliates.
import React from "react";
import PublicApply from "@/components/public/PublicApply";

export default function PartnerCompanySignup() {
  return (
    <PublicApply
      role="partner"
      roleTestId="partner-company-signup"
      defaultBusinessCategory="other"
      title="Partner your company with Lifted."
      blurb="For corporate partners with multiple locations or a national footprint. Lifted will assign you a partner account manager. Admin approval required."
      extraFields={[
        { key: "partner_type", label: "Hidden partner type", placeholder: "company", hidden: true, defaultValue: "company" },
        { key: "company_name", label: "Company name", placeholder: "Lifted Holdings Inc." },
        { key: "company_role", label: "Your role at the company", placeholder: "Director of Partnerships" },
        { key: "company_size", label: "Approximate # of locations", placeholder: "3 / 10 / 25+" },
        { key: "company_website", label: "Website (optional)", placeholder: "https://" },
      ]}
    />
  );
}
